// PARAQTA — Марафон бөлісетін карталары (Stage 10): старт нөмірі + финиш сертификаты.
// html2canvas → PNG → Web Share / жүктеу. Бренд: жасыл+алтын+крем.
// Қазақ глифтері үшін 'PT Serif' (Georgia-да ө/қ жоқ).

const SERIF = "'PT Serif', Georgia, serif";
const SANS = "'Onest', system-ui, sans-serif";
const GREEN = '#46583A', GOLD = '#C2A063', GOLDD = '#9E7C36', CREAM = '#F5EDD6', INK = '#2C2519', SOFT = '#7A6F55';

const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
}[c]));

// Дата ауқымы бас әріппен ("6–8 ШІЛДЕ · 3 КҮН") — m.start_date/end_date-тен динамикалық.
const MONTHS_UP = ['ҚАҢТАР', 'АҚПАН', 'НАУРЫЗ', 'СӘУІР', 'МАМЫР', 'МАУСЫМ',
  'ШІЛДЕ', 'ТАМЫЗ', 'ҚЫРКҮЙЕК', 'ҚАЗАН', 'ҚАРАША', 'ЖЕЛТОҚСАН'];
function dateRangeUp(m) {
  const s = m && m.start_date ? new Date(m.start_date) : null;
  const e = m && m.end_date ? new Date(m.end_date) : null;
  const days = (m && m.duration_days) || 3;
  if (s && e && !isNaN(s) && !isNaN(e)) {
    const mid = s.getMonth() === e.getMonth() ? MONTHS_UP[s.getMonth()]
      : `${MONTHS_UP[s.getMonth()]}–${MONTHS_UP[e.getMonth()]}`;
    return `${s.getDate()}–${e.getDate()} ${mid} · ${days} КҮН`;
  }
  return `6–8 ШІЛДЕ · ${days} КҮН`;
}

function frame(inner) {
  return `
  <div style="width:540px;height:960px;background:${CREAM};font-family:${SERIF};color:${INK};position:relative;box-sizing:border-box;overflow:hidden;">
    <div style="position:absolute;inset:22px;border:2px solid ${GOLD};border-radius:8px;"></div>
    <div style="position:absolute;inset:30px;border:1px solid ${GOLD};border-radius:5px;"></div>
    <div style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:64px 52px;box-sizing:border-box;">
      ${inner}
    </div>
  </div>`;
}

function numberCardHtml(m) {
  const num = m.my_number;
  return frame(`
    <div style="letter-spacing:7px;font-size:23px;font-weight:bold;color:${GREEN};font-family:${SANS};">PARAQTA</div>
    <div style="font-size:11px;letter-spacing:3px;color:${GOLDD};margin-top:7px;font-family:${SANS};">READING CHALLENGE</div>
    <div style="width:54px;height:1px;background:${GOLD};margin:28px 0;"></div>
    <div style="font-size:44px;color:${GREEN};line-height:1.05;">«${esc(m.book_title || 'Марафон')}»</div>
    <div style="font-size:13px;letter-spacing:2px;color:${SOFT};margin-top:10px;font-family:${SANS};">${dateRangeUp(m)}</div>
    <div style="font-size:12px;letter-spacing:5px;color:${GOLDD};margin-top:46px;font-family:${SANS};">МЕНІҢ НӨМІРІМ</div>
    <div style="font-size:130px;font-weight:bold;color:${GOLD};line-height:1;margin-top:2px;">#${num}</div>
    ${m.my_name ? `<div style="font-size:22px;color:${GREEN};margin-top:10px;">${esc(m.my_name)}</div>` : ''}
    <div style="font-size:16px;font-style:italic;color:${GREEN};margin-top:30px;">Мен қатысамын. Сен ше?</div>
    <div style="position:absolute;bottom:56px;left:0;right:0;font-size:13px;letter-spacing:3px;color:${GOLDD};font-family:${SANS};">paraqta.kz</div>
  `);
}

function certificateHtml(opts) {
  const { name, number, score, num_q, is_champion, rank, prize, book } = opts;
  const bk = book || 'Марафон';
  const isWinner = !!(is_champion && rank);
  const badge = isWinner
    ? `<div style="background:${GOLD};color:#2a1d0a;font-family:${SANS};font-weight:bold;font-size:13px;letter-spacing:3px;padding:8px 24px;border-radius:99px;margin-bottom:10px;">🏆 ЖЕҢІМПАЗ · ${rank}-ОРЫН</div>`
    : '';
  const scoreRow = (score != null && num_q != null)
    ? `<div><div style="font-size:52px;font-weight:bold;color:${GOLD};line-height:1;">${score}<span style="font-size:24px;color:${SOFT};">/${num_q}</span></div><div style="font-size:11px;letter-spacing:2px;color:${SOFT};margin-top:4px;font-family:${SANS};">КВИЗ ҰПАЙЫ</div></div>`
    : '';
  const numRow = number
    ? `<div><div style="font-size:52px;font-weight:bold;color:${GREEN};line-height:1;">#${number}</div><div style="font-size:11px;letter-spacing:2px;color:${SOFT};margin-top:4px;font-family:${SANS};">НӨМІР</div></div>`
    : '';
  const stats = (scoreRow || numRow)
    ? `<div style="display:flex;gap:34px;margin-top:28px;align-items:flex-end;">${scoreRow}${numRow}</div>` : '';
  const prizeRow = (isWinner && prize)
    ? `<div style="font-size:15px;color:${GOLDD};margin-top:20px;font-family:${SANS};font-weight:bold;">Жүлде: ${esc(prize)}</div>` : '';
  const confirmText = isWinner
    ? `«${esc(bk)}» оқу марафонының<br>жеңімпазы атанғанын растайды`
    : `«${esc(bk)}» оқу марафонына<br>қатысқанын растайды`;
  return frame(`
    ${badge}
    <div style="letter-spacing:7px;font-size:20px;font-weight:bold;color:${GREEN};font-family:${SANS};">PARAQTA</div>
    <div style="font-size:13px;letter-spacing:6px;color:${GOLDD};margin-top:12px;font-family:${SANS};">СЕРТИФИКАТ</div>
    <div style="width:54px;height:1px;background:${GOLD};margin:18px 0;"></div>
    <div style="font-size:14px;color:${SOFT};">Осы куәлік</div>
    <div style="font-size:34px;color:${GREEN};margin-top:8px;line-height:1.15;">${esc(name || 'Оқырман')}</div>
    <div style="font-size:15px;color:${SOFT};margin-top:12px;line-height:1.5;">${confirmText}</div>
    ${stats}
    ${prizeRow}
    ${opts.dates ? `<div style="font-size:13px;letter-spacing:2px;color:${SOFT};margin-top:30px;font-family:${SANS};">${esc(opts.dates)}</div>` : ''}
    <div style="position:absolute;bottom:56px;left:0;right:0;font-size:13px;letter-spacing:3px;color:${GOLDD};font-family:${SANS};">paraqta.kz</div>
  `);
}

async function composeAndShare(html, filename, title, text) {
  const wrap = document.createElement('div');
  wrap.style.cssText = 'position:fixed;left:-99999px;top:0;z-index:-1;pointer-events:none;';
  wrap.innerHTML = html;
  document.body.appendChild(wrap);
  const node = wrap.firstElementChild;
  try {
    const mod = await import('html2canvas');
    const html2canvas = mod.default || mod;
    const canvas = await html2canvas(node, {
      backgroundColor: CREAM, scale: 2, useCORS: true, logging: false,
      width: 540, height: 960, windowWidth: 540, windowHeight: 960,
    });
    const blob = await new Promise(r => canvas.toBlob(r, 'image/png', 0.95));
    if (!blob) return false;
    const file = new File([blob], filename, { type: 'image/png' });
    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
      try { await navigator.share({ files: [file], title, text }); return true; }
      catch (e) { if (e?.name === 'AbortError') return true; }
    }
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    return true;
  } catch (e) {
    console.error('marathon card share failed', e);
    return false;
  } finally {
    wrap.remove();
  }
}

export async function shareNumberCard(m) {
  if (!m || !m.my_number) return;
  const bk = m.book_title || 'Марафон';
  await composeAndShare(
    numberCardHtml(m),
    `paraqta-marathon-${m.my_number}.png`,
    `PARAQTA · «${bk}» марафоны`,
    `Мен «${bk}» марафонына тіркелдім! Нөмірім #${m.my_number}. paraqta.kz`
  );
}

export async function shareCertificate(opts) {
  const bk = opts.book || 'Марафон';
  await composeAndShare(
    certificateHtml(opts),
    `paraqta-sertifikat-${opts.number || ''}.png`,
    'PARAQTA · Сертификат',
    `«${bk}» марафонын аяқтадым! Квиз: ${opts.score}/${opts.num_q}. paraqta.kz`
  );
}

// Ескі fallback (Reading Challenge #1). Жаңа марафонда m.prizes қолданылады.
const MR_PRIZES = { 1: '35 000 ₸ + 5 кітап', 2: '15 000 ₸ + 3 кітап', 3: '10 000 ₸ + 2 кітап' };

// Ағымдағы марафонның жүлдесін орын бойынша алу (m.prizes массивінен).
// «🥇 1-орын — 26 томдық жинақ» → «26 томдық жинақ».
function prizeForRank(m, rank) {
  const arr = m && Array.isArray(m.prizes) ? m.prizes : null;
  if (!arr || !rank || rank < 1 || rank > arr.length) return null;
  return String(arr[rank - 1] || '').replace(/^[^—–-]*[—–-]\s*/, '').trim() || null;
}

// Марафон бетіне сертификат картасын инжекциялау — БАРЛЫҚ тіркелген қатысушыға.
// Жеңімпаз (my_quiz.is_champion + rank) болса — ерекше «ЖЕҢІМПАЗ» сертификаты.
export function injectCertCard(pageNode, m) {
  if (!m || (!m.is_registered && !m.my_quiz)) return;
  const mq = m.my_quiz || null;
  const isWinner = !!(mq && mq.is_champion && mq.rank);
  const champ = isWinner ? `<div class="mr-cert-champ">🏆 Жеңімпаз · ${mq.rank}-орын</div>` : '';
  const scoreLine = (mq && mq.score != null)
    ? `<div class="mr-quiz-sub">Квиз: <b>${mq.score}/${mq.total}</b>${mq.rank ? ` · ${mq.rank}-орын` : ''}</div>` : '';
  const bk = m.book_title || 'Марафон';
  const title = isWinner ? 'Жеңімпаз сертификатың дайын 🏆' : `«${esc(bk)}» марафоны сертификаты`;
  const card = document.createElement('section');
  card.className = 'mr-section';
  card.innerHTML = `
    <div class="mr-eyebrow">СЕРТИФИКАТ</div>
    <div class="mr-card mr-quiz-card">
      ${champ}
      <div class="mr-quiz-ttl">${title}</div>
      ${scoreLine}
      <div class="mr-quiz-sub" style="margin-top:4px;">Атыңмен сертификат — жүктеп ал, бөліс.</div>
      <button class="mr-cta-btn mr-cta-share" data-action="get-cert" style="margin-top:12px"><i class="ti ti-certificate"></i> Сертификатты алу</button>
    </div>`;
  const cta = pageNode.querySelector('.mr-cta-wrap');
  if (cta && cta.parentNode) cta.parentNode.insertBefore(card, cta);
  else pageNode.querySelector('.mr-page')?.appendChild(card);
  const btn = card.querySelector('[data-action="get-cert"]');
  if (btn) btn.addEventListener('click', () => shareCertificate({
    name: m.my_name, number: m.my_number, book: bk, dates: dateRangeUp(m),
    score: mq ? mq.score : null, num_q: mq ? mq.total : null,
    is_champion: isWinner, rank: mq ? mq.rank : null,
    prize: isWinner ? (prizeForRank(m, mq.rank) || MR_PRIZES[mq.rank]) : null,
  }));
}
